import {
    Scene,
    Engine,
    Color4,
    Vector3,
    SceneLoader,
    HemisphericLight,
    CubeTexture
} from '@babylonjs/core'
import '@babylonjs/loaders/glTF'

export class BabylonChatNpc {
    config = {
        debug: false,
        alpha: -0.943,
        beta: 1.205,
        radius: 2.1,
        target: [0.078, 0.9021, -0.0644]
    }
    el
    scene
    idleAnimation
    constructor(el, config) {
        this.config = Object.assign({}, this.config, config)
        this.el = el
    }
    async init() {
        this.el.innerHTML = ''
        const canvas = document.createElement('canvas')
        canvas.style.width = this.el.clientWidth + 'px'
        canvas.style.height = this.el.clientHeight + 'px'
        canvas.style.outline = 'unset'
        canvas.width = this.el.clientWidth
        canvas.height = this.el.clientHeight
        this.el.appendChild(canvas)
        const engine = new Engine(canvas, true)

        const scene = new Scene(engine)
        scene.clearColor = new Color4(0, 0, 0, 0)
        scene.clearColorAlpha = 0
        new HemisphericLight('light', new Vector3(0, 1, 0), scene)

        const { animationGroups } = await SceneLoader.ImportMeshAsync('', this.jsGetFileName(this.config.url)[0], this.jsGetFileName(this.config.url)[1], this.scene)
        scene.getMeshByName('O_Book')?.dispose()
        scene.getMeshByName('O_CH_Object_01')?.dispose()

        this.scene = scene
        scene.createDefaultCameraOrLight(true, true, true)
        if(this.config.hdr) {
            scene.environmentTexture = new CubeTexture(this.config.hdr, scene)

        }
        else {
            scene.createDefaultEnvironment({
                createSkybox: false,
                createGround: false,
            })
            scene.environmentIntensity = 3
        }



        scene.activeCamera.setTarget(Vector3.FromArray(this.config.target))
        scene.activeCamera.alpha = this.config.alpha
        scene.activeCamera.beta = this.config.beta
        scene.activeCamera.radius = this.config.radius
        scene.wheelDeltaPercentage = 0.01
        if(!this.config.debug) {
            scene.activeCamera.inputs.attached.keyboard.detachControl()
            scene.activeCamera.inputs.attached.mousewheel.detachControl()
            scene.activeCamera.beta = this.config.beta
            scene.activeCamera.lowerBetaLimit = this.config.beta
            scene.activeCamera.upperBetaLimit = this.config.beta
            scene.activeCamera.panningSensibility = 0
        }
        animationGroups[0].start(true, 1, animationGroups[0].from, animationGroups[0].to, false)
        window.camera = scene.activeCamera
        engine.runRenderLoop(() => {
            scene.render()
        })
        window.addEventListener('resize', () => {
            engine.resize()
        })
        if(this.debug) {
            window.addEventListener('keydown', (e) => {
                if(e.key === 's') {
                    e.stopPropagation()
                }
            })
        }
    }
    playAnimation(animationName, loop, speedRatio = 1) {
        this.stopAnimation()
        if(this.scene && this.scene.getAnimationGroupByName(animationName)) {
            const anim = this.scene.getAnimationGroupByName(animationName)
            anim.start(loop, speedRatio, anim.from, anim.to, false)
        }
    }
    stopAnimation() {
        if(!this.scene) return
        this.scene.animationGroups.forEach(animationGroup => {
            animationGroup.stop()
        })
    }
    animationGroups() {
        if(!this.scene) return
        const animationGroups = []
        for(const item of this.scene.animationGroups) {
            animationGroups.push(item.name)
        }
        return animationGroups
    }
    cameraAttribute() {
        if(!this.scene) return
        return {
            alpha: this.scene.activeCamera.alpha,
            beta: this.scene.activeCamera.beta,
            radius: this.scene.activeCamera.radius,
            target: this.scene.activeCamera.target.asArray()
        }
    }
    jsGetFileName(path) {
        const obj = path.lastIndexOf('/')
        return [path.substr(0, obj) + '/', path.substr(obj + 1)]
    }
}